module.exports = __webpack_public_path__ + "resources/img/img-security-securegate-1-jp.7278566a847b5c41fa56b0a238a0abf3.png";